import { Tabs as OWCTabs } from "owc-react-lib-common";
import * as React from 'react';
import { StyleSheet } from 'react-native';
import { isNumber } from "src/utils/TextUtils";
import { View } from "./View";

interface ITabs {
  id?: string;
  headers: ITabHeaders;
  children: any[];
  initialTab?: number | string;
  onChangeTab?: (tab: number) => void;
}

type ITabHeader = {
  name: string;
  label: string;
}

export type ITabHeaders = string[] | ITabHeader[];

const getSelectedTabIndex = (id: string, headers: ITabHeaders, initialTab: string | number) => {
  if(!id || isNumber(initialTab)) {
    return parseInt(initialTab + "");
  }

  return Math.max(0, headers.findIndex((header) => typeof header !== "string" && header.name === initialTab));
}

export const Tabs = ({ id, headers = [], children, initialTab = 0, onChangeTab }: ITabs) => {
  const qstring = !!id && id + "__tab";
  const [selected, setSelected] = React.useState(getSelectedTabIndex(qstring, headers, initialTab));

  /**
   * handle change
   */
  const handleChange = React.useCallback((index: number) => {
    setSelected(index);
    onChangeTab?.(index);

    if(!qstring || index === selected) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    params.delete(qstring);
    params.append(qstring, index + "");

    const url = window.location.href.split("?")[0] + "?" + params.toString();
    window.history.pushState({ path: url }, "", url);
  }, [qstring, onChangeTab, selected]);

  /**
   * render
   */
  const finalHeaders: string[] = [];

  headers.forEach((header: string | ITabHeader) => {
    if (!header) {
      return;
    }

    if (typeof header === "string") {
      finalHeaders.push(header);
      return;
    }

    finalHeaders.push(header.label);
  })

  return (
    <View>
      <View style={{ width: '100%' }}>
        <OWCTabs tabnames={finalHeaders} onChangeTab={handleChange} defaultTab={selected}>
          {headers.map((_header: any, idx: number) => <View key={idx} />)}
        </OWCTabs>
      </View>

      {children?.map((child: any, idx: number) => (
        <View key={idx} style={[styles.tab, idx !== selected && styles.hidden]}>
          {child}
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  hidden: {
    display: 'none',
  },
  tab: {
    // paddingTop: styling.spacing,
  },
});